<template>
  <Modal class-name="wuxing-compare3"  v-model="show" title="五行图辨证对比" width="1100" :mask-closable="false" footer-hide>
    <wuxingCompare :activeItem="activeItem" v-if="show" isModal />
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      activeItem: {},
      show: false,
    }
  },
  methods: {
    open(data) {
      this.activeItem = data;
      this.show = true;
    },
  }
}
</script>
<style lang="scss">
.wuxing-compare3{
  .ivu-modal-content{
    background: #fff;
  }
}
</style>
